import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// Component for seed widget

// Seed is a value which, when used, ensures that different generations
// with the same prompt are unique from one another.

export default function Seed(props) {
    // Randomize seed value to integer between 1 and 100
    const randomizeSeed = () => {
        let rand = Math.floor((Math.random() * 100) + 1);
        props.setSeed(rand);
    }

    return (
        <div>
            <span>
                Seed
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-disabled">
                            Choose the seed number or starting point for the generator
                        </Tooltip>
                    }
                >
                    <span style={{ marginLeft: "0.5vw" }}>ⓘ</span>
                </OverlayTrigger>
            </span>
            <div id="seed-options">
                <Form.Control
                    id="Seed"
                    style={{ padding: "5px" }}
                    type="text"
                    value={props.seed}
                    onChange={(e) => props.setSeed(parseInt(e.target.value))}
                />
                <button id="randomize-seed" onClick={randomizeSeed}>Randomize seed!</button>
            </div>
        </div>
    );
}
